import API from 'services/API';

// deprecated see hasUnits
export default function getIncomesTabStatus() {
  return API.request({
    method: 'GET',
    url: '/taxpayer/hasIncomeTabs',
  });
}
